






































































import { Component, Vue, Prop } from 'vue-property-decorator';
import { State, Action, Getter } from 'vuex-class';
import { ProfileState, User } from '@/store/profile/types';
import { Wallet } from '@/store/wallet/types';
import ExporoTooltip from '@/components/_common/Tooltip.vue';

@Component({
  name: 'app-header',
  components: {
    ExporoTooltip,
  },
})
export default class AppHeader extends Vue {
  @Prop({ default: 0, required: true }) balance: string;

  get emoneyDisabled(): boolean {
    return process.env.VUE_APP_EMONEY_DISABLED === 'true';
  }
}

